export type HeadingLevel = "h1" | "h2" | "h3";

export type HeadingStyle = HeadingLevel | "text-xl";

export type TitleHeadingPair = `${HeadingLevel}-${HeadingStyle}`;

const DEFAULT_HEADING_LEVEL: HeadingLevel = "h1";

const headingClassByLevel: Record<HeadingStyle, string> = {
  h1: "heading-xl",
  h2: "heading-lg",
  h3: "heading-md",
  "text-xl": "text-xl",
};

const isHeadingLevel = (value: string): value is HeadingLevel =>
  value === "h1" || value === "h2" || value === "h3";

const isHeadingStyle = (value: string): value is HeadingStyle =>
  isHeadingLevel(value) || value === "text-xl";

export const resolveTitleHeadingPair = (value: unknown) => {
  const normalized = typeof value === "string" ? value.trim().toLowerCase() : "";
  const separatorIndex = normalized.indexOf("-");
  const tagCandidate =
    separatorIndex >= 0 ? normalized.slice(0, separatorIndex) : normalized;
  const styleCandidate =
    separatorIndex >= 0 ? normalized.slice(separatorIndex + 1) : "";

  const titleTag = isHeadingLevel(tagCandidate)
    ? tagCandidate
    : DEFAULT_HEADING_LEVEL;
  const styleLevel = isHeadingStyle(styleCandidate)
    ? styleCandidate
    : DEFAULT_HEADING_LEVEL;

  return {
    titleTag,
    styleLevel,
    titleClassName: headingClassByLevel[styleLevel],
  };
};
